import React from 'react';
import { Box, Typography } from '@mui/material';
import PageLayout from '../components/common/PageLayout';

export default function TempleTrendsPage() {
  return (
    <PageLayout contentMaxWidth="lg" showHeaderImage={false} showOrgHeader>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Temple Trends
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Visual insights and trends for Temple programs.
        </Typography>
      </Box>
      <Box
        sx={{
          py: 6,
          textAlign: 'center',
          borderRadius: 2,
          border: '1px dashed',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Typography variant="h6" sx={{ mb: 1 }}>
          Coming soon
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Additional trend visualizations for Temple will appear here.
        </Typography>
      </Box>
    </PageLayout>
  );
}

